import { PORTAL_ROUTE } from 'src/constants/routes';

export const MANAGED_POLICIES_ROUTE = `${PORTAL_ROUTE}/environments/managed-policies`;
export const DEPLOYMENT_RINGS_ROUTE = `${PORTAL_ROUTE}/environments/deployment-rings`;

export const ENVIRONMENT_TABS = [
  {
    label: 'Summary',
    value: `${PORTAL_ROUTE}/environments/summary`,
  },
  {
    label: 'Detected Policies',
    value: `${PORTAL_ROUTE}/environments/detected-policies`,
  },
  {
    label: 'Managed Policies',
    value: MANAGED_POLICIES_ROUTE,
  },
  {
    label: 'Deployment Rings',
    value: DEPLOYMENT_RINGS_ROUTE,
  },
  {
    label: 'Status Settings',
    value: `${PORTAL_ROUTE}/environments/status-settings`,
  },
];
